// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 54 54", width: "54", height: "54" }, props),
        React.createElement(React.Fragment, null,
            React.createElement("g", { clipPath: "url(#Archive54x54__a)" },
                React.createElement("path", { d: "M33.4402 24.5454H20.5512C18.1797 24.5454 16.255 22.3462 16.255 19.6363H3.375V49.1006C3.375 51.808 5.29533 54 7.66255 54H46.3374C48.7068 54 50.625 52.4192 50.625 49.7143V19.6363H37.7364C37.7364 22.3462 35.8117 24.5454 33.4402 24.5454ZM49.5089 0H4.49107C2.0093 0 0 2.19445 0 4.89935V14.7273H54V4.89935C54 2.19445 51.9884 0 49.5089 0Z" })),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "Archive54x54__a" },
                    React.createElement("path", { fill: "#fff", d: "M0 0H54V54H0z" }))))));
};
Icon.displayName = 'Archive54x54';
export default Icon;
//# sourceMappingURL=Archive54x54.js.map